import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listCarrierPickupLocations = (cartId) =>
  axios.get(
    `${getV1RootUrl()}/cart/${cartId}/carrier-pickup-location`,
    publicAxiosHeader()
  );

export const addCarrierPickupLocation = (cartId, address) =>
  axios.post(
    `${getV1RootUrl()}/cart/${cartId}/carrier-pickup-location`,
    address,
    publicAxiosHeader()
  );

export const removeCarrierPickupLocation = (cartId) =>
  axios.delete(
    `${getV1RootUrl()}/cart/${cartId}/carrier-pickup-location`,
    publicAxiosHeader()
  );
